import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  TargetDeliveryTemplateAccessFunction,
  TargetDeliveryTemplateAccessFunctionMenuActionsType,
} from 'data/targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.types';
import './target-delivery-templateAccess-function-menu.scss';

type Props = {
  selectedTargetDeliveryTemplate?: TargetDeliveryTemplateAccessFunction;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const TargetDeliveryTemplateAccessFunctionMenu: FunctionComponent<Props> = ({
  selectedTargetDeliveryTemplate,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedTargetDeliveryTemplate == null) {
    return null;
  }

  return (
    <div data-testid="TargetDeliveryTemplateAccessFunctionMenu" className="target-delivery-templateAccess-function-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="target-delivery-templateAccess-function-menu-button"
        data-testid={`${TargetDeliveryTemplateAccessFunctionMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="target-delivery-templateAccess-function-menu-button"
        data-testid={`${TargetDeliveryTemplateAccessFunctionMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('targetDeliveryTemplateAccessFunction.deletePopup.title')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedTargetDeliveryTemplate.name })
        }
        actionText={t('targetDeliveryTemplateAccessFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default TargetDeliveryTemplateAccessFunctionMenu;
